export interface IFeatureFlagData {
    active: Set<string>
}

export function parseFeatureFlagData(data?: string): IFeatureFlagData {
    return {
        active: data ? new Set(data.split(",")) : new Set<string>(),
    }
}
